import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'folder/:id',
    loadChildren: () => import('./folder/folder.module').then(m => m.FolderPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'attendance',
    loadChildren: () => import('./pages/attendance/attendance.module').then(m => m.AttendancePageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'calendar',
    loadChildren: () => import('./pages/calendar/calendar.module').then(m => m.CalendarPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'gallery',
    loadChildren: () => import('./pages/gallery/gallery.module').then(m => m.GalleryPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'events',
    loadChildren: () => import('./pages/events/events.module').then(m => m.EventsPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'exams',
    loadChildren: () => import('./pages/exams/exams.module').then(m => m.ExamsPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'announcements',
    loadChildren: () => import('./pages/announcements/announcements.module').then(m => m.AnnouncementsPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'circular',
    loadChildren: () => import('./pages/circular/circular.module').then(m => m.CircularPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'student',
    loadChildren: () => import('./pages/student/student.module').then(m => m.StudentPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'fee',
    loadChildren: () => import('./pages/fee/fee.module').then(m => m.FeePageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'attendancecalendar',
    loadChildren: () => import('./pages/attendancecalendar/attendancecalendar.module').then(m => m.AttendancecalendarPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'timetable',
    loadChildren: () => import('./pages/timetable/timetable.module').then(m => m.TimetablePageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'grades',
    loadChildren: () => import('./pages/grades/grades.module').then(m => m.GradesPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'reminder',
    loadChildren: () => import('./pages/reminder/reminder.module').then(m => m.ReminderPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'notifications',
    loadChildren: () => import('./pages/notifications/notifications.module').then(m => m.NotificationsPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'feedback',
    loadChildren: () => import('./pages/feedback/feedback.module').then(m => m.FeedBackPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'imageviewer',
    loadChildren: () => import('./pages/imageviewer/imageviewer.module').then(m => m.ImageViewerPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'forgotpassword',
    loadChildren: () => import('./pages/forgotpassword/forgotpassword.module').then(m => m.ForgotPasswordPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'changepassword',
    loadChildren: () => import('./pages/changepassword/changepassword.module').then(m => m.ChangepasswordPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'logout',
    loadChildren: () => import('./pages/logout/logout.module').then(m => m.LogoutPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'detail-circular',
    loadChildren: () => import('./pages/detail-circular/detail-circular.module').then(m => m.DetailCircularPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'detail-announcements',
    loadChildren: () => import('./pages/detail-announcements/detail-announcements.module').then(m => m.DetailAnnouncementsPageModule),
    // canActivate: [AuthGuardService],
  }



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
